import React from 'react'

import { FilterDropdown } from '@components/common/FilterDropdown'
import { Checkbox, useMediaQueryContext } from '@fourthwall/components'
import { useFormik } from '@fourthwall/utils/dist/formik'

import { useFilterProducts } from '../../hooks/useFilterProducts'
import * as S from './styled'

export type FilterFormValues = {
  status: string[]
  stock: string[]
}

const statuses = [
  { label: 'Public', value: 'PUBLIC' },
  { label: 'Hidden', value: 'HIDDEN' },
  { label: 'Archived', value: 'ARCHIVED' },
]
const stockOptions = [
  { label: 'Available', value: 'AVAILABLE' },
  { label: 'Sold out', value: 'SOLD_OUT' },
]

export const ProductsFilter = () => {
  const { filtersParams, setFiltersParams, resetFiltersParams, hasFilterParams } =
    useFilterProducts()

  const media = useMediaQueryContext()
  const formik = useFormik<FilterFormValues>({
    initialValues: {
      status: filtersParams.status ? filtersParams.status.split(',') : [],
      stock: filtersParams.stock ? filtersParams.stock.split(',') : [],
    },
    onSubmit: (values: FilterFormValues) => {
      setFiltersParams({
        status: values.status.length ? values.status.join(',') : undefined,
        stock: values.stock.length ? values.stock.join(',') : undefined,
      })
    },
  })

  const handleReset = () => {
    formik.resetForm()
    resetFiltersParams()
  }

  const handleCheckboxGroupChange = (checked: boolean, value: string, name: string) => {
    const fieldValue = checked
      ? [...(formik.values as any)[name], value]
      : (formik.values as any)[name].filter((v: any) => v !== value)

    formik.setFieldValue(name, fieldValue)
  }

  const renderStatuses = () => (
    <S.FiltersColumn>
      <FilterDropdown.GroupTitle title="Status" />
      <S.CheckboxGroup role="group">
        {statuses.map((status) => (
          <Checkbox
            native
            key={status.value}
            label={status.label}
            value={status.value}
            checked={formik.values.status.includes(status.value)}
            onValueChange={(checked) => handleCheckboxGroupChange(checked, status.value, 'status')}
          />
        ))}
      </S.CheckboxGroup>
    </S.FiltersColumn>
  )

  const renderAvailabilitiesOptions = () => (
    <S.FiltersColumn>
      <FilterDropdown.GroupTitle title="Stock" />
      <S.CheckboxGroup role="group">
        {stockOptions!.map((option) => (
          <Checkbox
            native
            key={option.value}
            label={option.label}
            value={option.value}
            checked={formik.values.stock.includes(option.value)}
            onValueChange={(checked) => handleCheckboxGroupChange(checked, option.value, 'stock')}
          />
        ))}
      </S.CheckboxGroup>
    </S.FiltersColumn>
  )

  const renderContent = () => {
    if (!media.tablet) {
      return (
        <S.Form>
          {renderStatuses()}
          {renderAvailabilitiesOptions()}
        </S.Form>
      )
    }

    return (
      <S.Form>
        <S.FormRow>
          {renderStatuses()}
          {renderAvailabilitiesOptions()}
        </S.FormRow>
      </S.Form>
    )
  }

  return (
    <FilterDropdown
      content={renderContent()}
      activityIndicator={hasFilterParams || !!formik.values.stock.length}
      onSubmit={formik.handleSubmit}
      onReset={handleReset}
    />
  )
}
